import { Injectable } from '@angular/core';
import { RequestCriteria } from '../../model/request-criteria';
import { SessionStorageService } from 'src/app/common/service/session-storage.service';
import { UserSettingsService } from 'src/app/settings/service/user-settings.service';
import { FilterHistoryManager } from './filter-history-manager';
import { EMPTY, Observable } from 'rxjs';
import { UserProfileService } from 'src/app/common/service/user-profile.service';

@Injectable()
export class FilterHistoryService {

  private maxSize: number;
  private history: Map<string, FilterHistoryManager> = new Map();

  constructor(private storage: SessionStorageService, private settings: UserSettingsService, private userService: UserProfileService) {
    this.maxSize = this.settings.getFilterHistoryMaxSize();
  }

  getManager(key: string): FilterHistoryManager {
    if (this.isEnable && key) {
      if (!this.history.has(this.userKey(key))) this.history.set(this.userKey(key), new FilterHistoryManager(this.storage, this.maxSize, this.userKey(key)));
      return this.history.get(this.userKey(key));
    }
  }

  put(key: string, clientId: string, criteria: RequestCriteria): void {
    if (this.isEnable && criteria) {
      const manager = this.getManager(key);
      manager.put(clientId, criteria);
    }
  }

  getRecent(key: string, clientId: string): RequestCriteria {
    if (this.isEnable) {
      const manager = this.getManager(key);
      return manager.getRecent(clientId);
    }
    return null;
  }

  getNavigateObs$(key: string, clientId: string): Observable<RequestCriteria> {
    if (this.isEnable) {
      const manager = this.getManager(key);
      return manager.getNavigateObs$(clientId);
    }
    return EMPTY;
  }

  save(key: string): void {
    if (this.isEnable && this.history.has(this.userKey(key))) {
      this.getManager(key).save();
    }
  }

  setRecent(key: string, idx: number): void {
    if (this.isEnable)
      this.getManager(key).setRecent(idx);
  }

  remove(key: string): void {
    this.history.delete(this.userKey(key));
  }

  get isEnable(): boolean {
    return this.maxSize > 0;
  }

  private userKey(key: string): string {
    return `${this.userService.getUserId()}-${key}`;
  }
}
